var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00065 2.27441C4.32065 2.27441 1.33398 5.26108 1.33398 8.94108C1.33398 12.6211 4.32065 15.6077 8.00065 15.6077C11.6807 15.6077 14.6673 12.6211 14.6673 8.94108C14.6673 5.26108 11.6807 2.27441 8.00065 2.27441ZM8.00065 9.60775C7.63398 9.60775 7.33398 9.30775 7.33398 8.94108V6.27441C7.33398 5.90775 7.63398 5.60775 8.00065 5.60775C8.36732 5.60775 8.66732 5.90775 8.66732 6.27441V8.94108C8.66732 9.30775 8.36732 9.60775 8.00065 9.60775ZM8.66732 12.2744H7.33398V10.9411H8.66732V12.2744Z",
    fill: "#33C16C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoColor);
export default __webpack_public_path__ + "static/media/infoColor.4e28ed9550fad824e15c6c4163c2f772.svg";
export { ForwardRef as ReactComponent };